import { Chat_ChatBan as IChatBan } from "client/graphql"
import { FormattedMessage } from "react-intl"
import { AccentButton } from "shared/components/buttons/AccentButton"
import { P } from "shared/styles/textStyles"
import styled from "styled-components"

const Wrapper = styled.li`
  display: flex;
  padding: 10px 2px;
`

const UserInfo = styled.div`
  flex-grow: 1;
  text-align: left;
  color: ${(props) => props.theme.colors.dark};
`

const DisplayName = styled(P)`
  margin: unset;
  font-weight: 600;
  font-size: 0.92rem;
`

const BannedDate = styled(P)`
  font-size: 0.92rem;
`

// Format as `DD/MM/YYYY`
const formatDate = (date: Date): string =>
  `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`

export type ChatBanItemProps = {
  chatBan: IChatBan
  unbanUser: (user: { userId: string; sourceName: string }) => void
}

export const ChatBanItem = ({
  chatBan: { displayName, createdAt, userId, sourceName },
  unbanUser,
}: ChatBanItemProps) => (
  <Wrapper>
    <UserInfo>
      <DisplayName>
        {displayName || (
          <FormattedMessage
            id="chatBan.unknownDisplayName"
            defaultMessage="Unknown"
          />
        )}
      </DisplayName>
      <BannedDate>{`Date banned: ${formatDate(
        new Date(createdAt),
      )}`}</BannedDate>
    </UserInfo>
    <AccentButton
      onClick={() => unbanUser({ userId, sourceName })}
      style={{ fontSize: "0.92rem", height: "35px" }}
      data-robot="unban-user"
    >
      <FormattedMessage id="chatBan.unbanButton" defaultMessage="Unban" />
    </AccentButton>
  </Wrapper>
)
